// extracted by mini-css-extract-plugin
module.exports = {"titre":"About_titre__1Merb","mobile":"About_mobile__2XUBq"};